<template>
  <th :colspan="headers.length">
    <div class="d-flex align-center">
      <v-btn icon small rounded @click="toggle" class="bordered-1">
        <v-icon color="primary"
          >mdi-chevron-{{ isOpen ? "down" : "right" }}</v-icon
        >
      </v-btn>
      <span class="mx-2 text-subtitle-2 text-capitalize font-weight-bold">
        {{ group }}
        <span class="text--secondary">
          ({{
            $options.filters.addComma(totalItems !== null ? totalItems : items.length)
          }})
        </span>
        <!-- $options.filters.addComma(totalItems !== undefined ? totalItems : items.length) (orginal code) -->
      </span>
      <v-btn text outlined rounded small v-if="showRemoveIcon" @click="remove">
        <v-icon small class="mr-2">{{ $vuetify.icons.values.undo }}</v-icon>
        ungroup
      </v-btn>
    </div>
  </th>
</template>

<script>
// Libraries
import { mapGetters } from "vuex";

// Components

export default {
  name: "GroupByHeaderRow",
  data() {
    return {};
  },
  props: {
    totalItems: {
      // For custom amount value
      default: null,
      type: Number,
    },
    headers: {
      default: [],
      type: Array,
    },
    group: {
      default: "",
      type: String,
    },
    items: {
      default: [],
      type: Array,
    },
    isOpen: {
      default: true,
      type: Boolean,
    },
    showRemoveIcon: {
      default: true,
      type: Boolean,
    },
  },
  methods: {
    /* API */
    // GET
    // POST
    /* */
    toggle() {
      this.$emit("toggle");
    },
    remove() {
      this.$emit("remove");
    },
  },
  computed: {
    ...mapGetters([
      // Main
      "getAppName",
      "getUser",
    ]),
  },
};
</script>
